import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';
import { IconActionChevronRight16, IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import styles from './styles.css';
import { ICustomSwiperNavigationRef } from 'shared/components/CustomSwiper';
import { LayoutBlock } from 'shared/components/LayoutBlock';

interface IContainerProps {
  title: string;
  sectionTabTitle: string;
  description: string;
  carousel: ReactNode;
  navRef: ICustomSwiperNavigationRef;
}

export const StandardLayout: FC<IContainerProps> = ({ title, carousel, description, navRef, sectionTabTitle }) => (
  <LayoutBlock id="pik-standard" sectionTabTitle={sectionTabTitle} title={title} description={description}>
    <div className={styles['carousel']}>
      <button className={clsx(styles['button'], styles['prev'])} type="button" ref={navRef.prev}>
        <IconActionChevronLeft16 color="icon-secondary-default" />
      </button>
      <button className={clsx(styles['button'], styles['next'])} type="button" ref={navRef.next}>
        <IconActionChevronRight16 color="icon-secondary-default" />
      </button>
      {carousel}
    </div>
  </LayoutBlock>
);
